import { render, staticRenderFns } from "./PageLinks.vue?vue&type=template&id=5cdbb506"
import script from "./PageLinks.vue?vue&type=script&lang=js"
export * from "./PageLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports